if (!customElements.get('accessories-bundle')) {
  class AccessoriesBundle extends HTMLElement {
    constructor() {
      super();
      this.initialize();
    }

    initialize() {
      this.attachEventListeners([
        { selector: '.variant-selector', event: 'change', handler: this.handleVariantChange.bind(this) },
        { selector: '.update-accessory', event: 'click', handler: this.handleClickUpdateBtn.bind(this) },
        { selector: '.add-accessory', event: 'click', handler: this.handleClickUpdateBtn.bind(this) },
        { selector: '.return-btn', event: 'click', handler: AccessoriesBundle.handleCancelBtnClick },
      ]);
    }

    attachEventListeners(events) {
      events.forEach(({ selector, event, handler }) => {
        const elements = this.querySelectorAll(selector);
        elements.forEach((element) => {
          element.addEventListener(event, handler);
        });
      });
    }

    handleVariantChange(event) {
      const selectedOption = event.target.options[event.target.selectedIndex];
      const listItem = event.target.closest('li');

      if (!listItem || !selectedOption) return;

      const variantId = selectedOption.value;
      const imageUrl = selectedOption.getAttribute('data-image');
      const price = selectedOption.getAttribute('data-price');

      listItem.querySelectorAll('.variant-selector').forEach((selector) => {
        selector.value = variantId;
      });

      const accessoryImg = listItem.querySelector('.accessory-img');
      if (accessoryImg) {
        accessoryImg.src = imageUrl;
      }

      listItem.setAttribute('data-variantid', variantId);
      listItem.querySelectorAll('.price__current').forEach((priceElement) => {
        priceElement.textContent = price;
      });
    }

    handleClickUpdateBtn(event) {
      const listItem = event.target.closest('li');
      if (!listItem) return;

      const checkbox = listItem.querySelector('.accessory-checkbox');
      if (checkbox) {
        checkbox.checked = true;
        checkbox.setAttribute('aria-checked', 'true');
      }

      AccessoriesBundle.handleCancelBtnClick(event);
    }

    static handleCancelBtnClick(event) {
      const sideDrawer = event.target.closest('side-drawer');
      if (sideDrawer) {
        sideDrawer.close();
      }
    }
  }

  customElements.define('accessories-bundle', AccessoriesBundle);
}
